import { $, $$, isTablet, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, EffectFade, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-pe-card-slider]')) return;

  const slidersArray = [];

  addEventListeners(slidersArray);
  buildSlider(slidersArray, isTablet.matches);
}

function addEventListeners(slidersArray) {
  isTablet.addEventListener('change', () => einstuerzendeNeubauten(slidersArray));

  if ($('[data-au-featured-news-tab]')) {
    $$('[data-au-featured-news-tab]').forEach((tab) => {
      tab.addEventListener('click', () => einstuerzendeNeubauten(slidersArray));
    });
  }
}

function buildSlider(slidersArray, isTablet) {
  const peSliderConfig = {
    on: {
      slideChange: (e) => {
        $$('[data-au-pe-card-video]').forEach((video) => video.pause());
        $$('[data-au-pe-card]')[e.activeIndex].querySelector('video')?.play();
      },
    },
  };

  $$('[data-au-pe-card-slider]').forEach((slider) => {
    if (isTablet) {
      const peSlider = new Swiper(slider, {
        modules: [Scrollbar, A11y, FreeMode],
        ...sliderConfig,
        ...peSliderConfig,
      });

      slidersArray.push(peSlider);
      return;
    }

    const peSlider = new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, EffectFade],
      ...sliderConfig,
      ...peSliderConfig,
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });

    slidersArray.push(peSlider);
  });
}

function einstuerzendeNeubauten(slidersArray) {
  slidersArray.forEach((slider) => slider.destroy());
  buildSlider(slidersArray, isTablet.matches);
}

export default { init };
